import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Dashboard from '../Dashboard';

import styles from './styles';

class Home extends Component {
  static propTypes = {
  };

  state = {};

  componentWillMount() {
  }

  render() {
    return (
      <Dashboard title="" style={styles.dashboard}>
        <div style={styles.welcome}>
          <div>Welcome</div>
          <div>to</div>
          <img src="/images/logo-inverse.png" alt="Logo"/>
        </div>
      </Dashboard>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

function mapStateToProps(state) {
  return {
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/components/Home/index.js